import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import TwoColumns from "@modules/TwoColumns/version2"
import { useBreakpoints } from "@hooks/useBreakpoints"
import { removeBolds } from "@utils/helpers"

const AboutMetaloop = () => {
  const { t } = useTranslation()
  const { isDesktop } = useBreakpoints()

  const params = {
    imageUrl: "Jan_sascha2.png",
    headerText: t("AboutMetaloop_Section1"),
    contentText: `${
      isDesktop
        ? removeBolds(t("AboutMetaloop_Paragraph1"))
        : t("AboutMetaloop_Paragraph1")
    }<br/><br/>${
      isDesktop
        ? removeBolds(t("AboutMetaloop_Paragraph2"))
        : t("AboutMetaloop_Paragraph2")
    }<br/><br/>${t("AboutMetaloop_Paragraph3")}`,
    theme: "white-bg",
    classes: {
      topDiv: "desk:!pl-0 desk:!pb-0 desk:!pr-0 md:!pl-[24px] md:!pr-[20px]",
      image: "max-h-[300px]",
      divText: "desk:!pr-[100px]",
    },
  }

  return <TwoColumns {...params} />
}

export default AboutMetaloop
